<template>
  <div class="phone-customize">
    <second-menu-link-content>
      <template v-slot:header>
        <span>自定义页面</span>
      </template>
      <template v-slot:content>
        <div class="phone-customize-main" ref="main">
          <div class="preview">
            <div class="editor">
              <div class="set">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9897"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    d="M1009.152 486.4l-226.304-392.192c-9.216-15.872-26.112-25.6-44.544-25.6H285.696c-18.432 0-35.328 9.728-44.544 25.6L14.848 486.4c-9.216 15.872-9.216 35.328 0 51.2l226.304 392.192c9.216 15.872 26.112 25.6 44.544 25.6h453.12c18.432 0 35.328-9.728 44.544-25.6l226.304-392.192c8.704-15.872 8.704-35.328-0.512-51.2z m-276.48 407.552H291.328l-220.16-381.952L291.84 130.048h440.832l220.672 381.952-220.672 381.952z"
                    fill="#1296db"
                    p-id="9898"
                  />
                  <path
                    d="M512 332.8c-98.816 0-179.2 80.384-179.2 179.2s80.384 179.2 179.2 179.2 179.2-80.384 179.2-179.2-80.384-179.2-179.2-179.2z m0 296.96c-65.024 0-117.76-52.736-117.76-117.76s52.736-117.76 117.76-117.76 117.76 52.736 117.76 117.76-52.736 117.76-117.76 117.76z"
                    fill="#1296db"
                    p-id="9899"
                  />
                </svg>
              </div>
              <div class="remove-up" @click="upModule">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1835"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    :fill="moduleIndex ===0 ||moduleIndex ===''?'#eeeeee':'#999999'"
                    d="M907.955934 352.01498L563.195206 7.254252a24.183503 24.183503 0 0 0-7.565833-5.089161c-0.087882-0.039946-0.167775-0.095871-0.263646-0.135818a24.071654 24.071654 0 0 0-3.890771-1.206379c-0.239678-0.055925-0.463377-0.159785-0.711045-0.207721-1.597853-0.319571-3.219674-0.487345-4.833505-0.487345H497.139968a24.279375 24.279375 0 0 0-19.669569 10.090441L135.65771 352.01498a24.367256 24.367256 0 0 0 0 34.473676l34.473676 34.481665a24.383235 24.383235 0 0 0 34.473676 0l268.151671-268.15966V999.616765a24.375246 24.375246 0 0 0 24.383235 24.383235h48.758481a24.375246 24.375246 0 0 0 24.375246-24.383235V152.243423l268.726898 268.726898a24.383235 24.383235 0 0 0 34.473676 0l34.473676-34.481665a24.367256 24.367256 0 0 0 0.007989-34.473676z"
                    p-id="1836"
                  />
                </svg>
              </div>
              <div class="remove-down" @click="downModule">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="1389"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    :fill="moduleIndex ===previewData.length-1||moduleIndex ===''?'#eeeeee':'#999999'"
                    d="M116.044066 671.98502L460.804794 1016.745748a24.183503 24.183503 0 0 0 7.565833 5.089161c0.087882 0.039946 0.167775 0.09587099 0.263646 0.135818a24.071654 24.071654 0 0 0 3.89077101 1.206379c0.239678 0.055925 0.463377 0.159785 0.71104499 0.207721 1.597853 0.319571 3.21967399 0.487345 4.833505 0.487345L526.860032 1023.872172a24.279375 24.279375 0 0 0 19.66956899-10.090441L888.34229001 671.98502a24.367256 24.367256 0 0 0-1e-8-34.473676l-34.47367601-34.481665a24.383235 24.383235 0 0 0-34.47367599 0l-268.151671 268.15966L551.243267 24.383235a24.375246 24.375246 0 0 0-24.383235-24.383235l-48.758481 0a24.375246 24.375246 0 0 0-24.375246 24.383235L453.726305 871.756577l-268.726898-268.726898a24.383235 24.383235 0 0 0-34.47367599 0l-34.47367601 34.481665a24.367256 24.367256 0 0 0-0.007989 34.473676z"
                    p-id="1390"
                  />
                </svg>
              </div>
              <div class="remove" @click="deleteModule">
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2557"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18"
                  height="18"
                >
                  <path
                    d="M519.669429 0c-104.534771 0-189.591705 82.942197-193.175627 186.875937H82.586757A49.195452 49.195452 0 0 0 33.391304 236.026869a49.195452 49.195452 0 0 0 49.195453 49.150931h54.315341v550.900024C136.902098 939.499576 207.111354 1023.97774 293.704254 1023.97774h441.690572c86.5929 0 156.802156-83.966175 156.802156-187.899916V285.689789h49.195453A49.195452 49.195452 0 0 0 990.587887 236.538858a49.195452 49.195452 0 0 0-49.195452-49.150932H712.333066A192.663638 192.663638 0 0 0 519.691689 0zM411.81786 178.083085c3.561662-50.063607 46.902633-89.041543 100.4166-89.041542C565.770687 89.041543 609.111658 128.019478 612.161331 178.083085h-200.343471z m-112.637551 756.341123c-31.16454 0-65.445534-39.356362-65.445534-95.586096V289.385013h578.770027v549.965088C812.504802 895.579835 778.223808 934.936197 747.059268 934.936197H299.180309v-0.511989z"
                    :fill="moduleIndex ===''?'#eeeeee':'#999999'"
                    p-id="2558"
                  />
                  <path
                    d="M367.297089 801.373883c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C411.81786 444.762505 391.783513 422.947327 367.297089 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C322.776318 779.558705 342.254155 801.373883 367.297089 801.373883z m155.8227 0c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C567.64056 444.762505 547.606213 422.947327 523.119789 422.947327s-44.520771 21.815178-44.520772 49.106411v280.213734C478.599017 779.558705 498.633364 801.373883 523.119789 801.373883z m133.562313 0c24.486424 0 44.520771-21.815178 44.520772-49.106411V472.053738C701.202874 444.762505 681.168527 422.947327 656.682102 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C612.161331 779.558705 631.639169 801.373883 656.682102 801.373883z"
                    :fill="moduleIndex ===''?'#eeeeee':'#999999'"
                    p-id="2559"
                  />
                </svg>
              </div>
            </div>
            <p class="preview-title">预览效果</p>
            <div class="preview-main">
              <template v-for="(value,index) in previewData">
                <div
                  :class="moduleIndex===index?'img-container border':'img-container'"
                  v-if="value.type===1"
                  :key="index"
                  @click="editorIndex(index)"
                >
                  <img class="img" :src="value.img" alt />
                </div>
                <div
                  :class="moduleIndex===index?'goods-container border':'goods-container'"
                  v-else
                  :key="index"
                  @click="editorIndex(index)"
                >
                  <ul class="goods-list">
                    <li class="goods" v-for="(v,i) in value.goods" :key="i">
                      <el-image class="img" :src="v.img" fit="contain"></el-image>
                      <div class="goods-content">
                        <div class="name">{{v.goodsName}}</div>
                        <div class="price-detail">
                          <p class="price">￥{{v.price}}</p>
                          <p class="detail">立即查看</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
              <div class="add">
                <div class="content" @click="changeAddContent">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="add-content">
            <div class="button">
              <el-button :class="status===1?'btn-blue':'btn-white'" @click="changeStatus(1)">添加图片</el-button>
              <el-button :class="status===2?'btn-blue':'btn-white'" @click="changeStatus(2)">添加商品</el-button>
            </div>
            <div class="img-container" v-show="status===1">
              <div class="img-upload">
                <p class="title">不限高度 支持jpg，png格式</p>
                <div class="upload">
                  <el-upload
                    :class="fileList.length === 1 ?'none':''"
                    action="#"
                    list-type="picture-card"
                    :auto-upload="true"
                    :before-upload="beforeUpload"
                    :on-remove="onRemove"
                    :file-list="fileList"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div class="link" v-show="fileList.length === 1">
                    <p class="link-lable">链接：</p>
                    <el-input class="white" v-model="link"></el-input>
                  </div>
                </div>
              </div>
              <div class="bottom-btn">
                <el-button class="btn-white" @click="cancel">取消</el-button>
                <el-button class="btn-blue" @click="addCustomize(1)">确定</el-button>
              </div>
            </div>
            <div class="goods-container" v-show="status===2">
              <p class="add-goods">
                <el-button class="btn-text" type="text" @click="addGoods">添加商品</el-button>
              </p>
              <ul class="goods-list">
                <li class="goods" v-for="(value,index) in goodsList" :key="index">
                  <el-image class="img" :src="value.img" fit="contain"></el-image>
                  <div class="name">{{value.name}}</div>
                  <p class="remove-goods" @click="removeGoods(index)">删除</p>
                </li>
              </ul>
              <div class="bottom-btn">
                <el-button class="btn-white" @click="cancel">取消</el-button>
                <el-button class="btn-blue" @click="addCustomize(2)">确定</el-button>
              </div>
            </div>
          </div>
          <el-dialog title="添加商品" :visible.sync="dialogTableVisible" width="1200px" top="20vh">
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <!-- 表格部分 -->
            <div class="input-search">
              <el-cascader
                clearable
                class="gray w160"
                v-model="dialogForm.classify"
                :options="classify"
                :props="defaultParams"
                placeholder="请选择分类"
                filterable
                :show-all-levels="false"
              ></el-cascader>
              <el-input class="gray" placeholder="请输入商品名称/商品编码" v-model="dialogForm.codeName"></el-input>
              <el-button type="text" class="btn-blue" @click="search">搜索</el-button>
            </div>
            <div class="table-img">
              <el-table
                height="260"
                :data="dialogTableData"
                ref="dialogTable"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="35"></el-table-column>
                <el-table-column label="商品图片" width="200">
                  <template slot-scope="scope">
                    <img v-if="scope.row.img" :src="scope.row.img" class="img" />
                    <img v-else src="http://ydbtest.cnpu.com/img/bigImg.42a4bd12.png" class="img" />
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称">
                  <template slot-scope="scope">
                    <p class="name">{{ scope.row.name }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="classify" label="商品分类"></el-table-column>
                <el-table-column prop="price" label="零售价"></el-table-column>
              </el-table>
            </div>
            <div class="table_pagination">
              <PaginationModul
                :pageSize="pageSize"
                :total="total"
                :currentPage="page"
                @queryChange="updatePage"
              ></PaginationModul>
            </div>
            <div id="footer">
              <!-- 取消关闭对话框 -->
              <el-button class="btn-white" @click="dialogTableVisible = false">取 消</el-button>
              <!-- 修改保存 -->
              <el-button class="btn-blue" type="primary" @click="save">确 定</el-button>
            </div>
          </el-dialog>
        </div>
        <div class="page-url">
          <el-input class="url" disabled>....</el-input>
          <p class="icon">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2160"
              width="15"
              height="15"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M619.52 399.36l-20.48-20.48-71.68 71.68c10.24 5.12 15.36 10.24 25.6 20.48l5.12 5.12c46.08 46.08 46.08 122.88 0 168.96l-194.56 194.56c-46.08 46.08-122.88 46.08-168.96 0l-5.12-5.12c-46.08-46.08-46.08-122.88 0-168.96l87.04-87.04c-15.36-35.84-20.48-76.8-20.48-117.76l-138.24 138.24c-87.04 87.04-87.04 225.28 0 307.2l5.12 5.12c87.04 87.04 225.28 87.04 307.2 0l194.56-194.56c81.92-87.04 81.92-225.28-5.12-317.44z m291.84-281.6c-87.04-87.04-225.28-87.04-312.32-5.12l-194.56 194.56c-87.04 87.04-87.04 225.28 0 307.2l5.12 5.12 20.48 20.48 71.68-71.68c-10.24-5.12-15.36-10.24-25.6-20.48l-5.12-5.12c-46.08-46.08-46.08-122.88 0-168.96l194.56-194.56c46.08-46.08 122.88-46.08 168.96 0l5.12 5.12c46.08 46.08 46.08 122.88 0 168.96l-87.04 87.04c15.36 35.84 20.48 76.8 20.48 117.76l138.24-138.24c81.92-76.8 81.92-215.04 0-302.08z"
                fill="#3D74F2"
                p-id="2161"
              />
            </svg>
          </p>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationModul from "base/PaginationTpl";
import ImgUploader from "models/img-upload.js";
import DBMall from "models/db/mall.js";
import DBCommodity from "models/db/commodity.js";
const dbCommodity = new DBCommodity();
const dbMall = new DBMall();
const imgUploader = new ImgUploader();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationModul
  },
  data() {
    return {
      previewData: [], //预览数据
      moduleIndex: "",
      // isAddContent: false, //右侧开关
      status: 1, //栏目切换
      fileList: [], //图片存储
      link: "", //图片链接
      goodsList: [], //添加的商品
      id: "",
      dialogForm: {
        classify: [],
        codeName: ""
      },
      dialogFormSearch: {
        classify: [],
        codeName: ""
      },
      classify: [], // 分类数据
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children"
      },
      dialogTableData: [],
      dialogTable: "",
      page: 1,
      total: 0,
      pageSize: 20,
      dialogTableVisible: false
    };
  },
  // watch: {
  //   isAddContent: {
  //     handler(value) {
  //       if (!value) {
  //         this.fileList = [];
  //         this.link = "";
  //         this.goodsList = [];
  //       }
  //     }
  //   }
  // },
  created() {
    this.getPreviewData();
    this.getGoodsClassify();
    this.getGoods();
  },
  mounted() {
    this.$refs["main"].style.height =
      document.querySelector(".content").offsetHeight - 140 + "px";
  },
  methods: {
    //或取预览页面数据
    getPreviewData() {
      dbMall.getDBCustomizeData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.type = value.type;
            if (value.type === 1) {
              obj.img = value.details[0].pic;
              obj.url = value.details[0].url;
            } else {
              obj.goods = [];
              value.details.map(value => {
                let goodsObj = {};
                goodsObj.goodsId = value.goodsId;
                goodsObj.goodsName = value.goodsName;
                goodsObj.price = value.marketPrice;
                goodsObj.img = value.itemImages[0]
                  ? value.itemImages[0]
                  : "http://ydbtest.cnpu.com/img/bigImg.42a4bd12.png";
                obj.goods.push(goodsObj);
              });
            }
            arr.push(obj);
          });
          this.previewData = arr;
        }
      });
    },
    // 获取商品分类列表
    getGoodsClassify() {
      dbCommodity.getDBGoodsClassify().then(res => {
        if (res.success) {
          this.classify = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取商品列表
    getGoods() {
      let goodsName = this.dialogFormSearch.codeName
        ? this.dialogFormSearch.codeName
        : "";
      let currentPage = this.page;
      let length = this.dialogFormSearch.classify.length - 1;
      let category1Id =
        this.dialogFormSearch.classify.length > 0
          ? this.dialogFormSearch.classify[length]
          : "";
      let options = {
        currentPage,
        goodsName,
        category1Id
      };
      dbCommodity.getCommodityFewMessage(options).then(res => {
        this.total = res.result.totalNum;
        this.pageSize = res.result.pageSize;
        let arr = [];
        res.result.items.map((value, index, array) => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.goodsName;
          obj.price = value.defaultPrice;
          obj.classify = value.categoryName;
          obj.img =
            value.itemImages.length > 0
              ? value.itemImages[0]
              : "http://ydbtest.cnpu.com/img/bigImg.42a4bd12.png";
          arr.push(obj);
        });
        this.dialogTableData = arr;
      });
    },
    //选中模块
    editorIndex(index) {
      if (index === this.moduleIndex) {
        this.changeAddContent();
      } else {
        this.moduleIndex = index;
        if (this.previewData[index].type === 1) {
          this.id = this.previewData[index].id;
          this.status = 1;
          this.fileList = [];
          this.goodsList = [];
          this.fileList.push({
            url: this.previewData[index].img
          });
          this.link = this.previewData[index].url;
        } else {
          this.id = this.previewData[index].id;
          this.status = 2;
          this.goodsList = [];
          this.fileList = [];
          this.link = "";
          this.previewData[index].goods.map(value => {
            let obj = {};
            obj.id = value.goodsId;
            obj.img = value.img;
            obj.name = value.goodsName;
            this.goodsList.push(obj);
          });
        }
      }
    },
    // 上移
    upModule() {
      if (this.moduleIndex === "") {
        console.log("请选择");
      } else {
        if (this.moduleIndex === 0) {
          console.log("该已是第一个图片");
        } else {
          let obj = this.previewData[this.moduleIndex];
          this.previewData.splice(this.moduleIndex, 1);
          this.previewData.splice(this.moduleIndex - 1, 0, obj);
          this.moduleIndex -= 1;
          let data = [];
          this.previewData.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sortValue = (index + 1) * 100;
            data.push(obj);
          });
          dbMall.postDBSortCustomize(data).then(res => {
            if (res.success) {
              console.log("成功");
            }
          });
        }
      }
    },
    // 下移
    downModule() {
      if (this.moduleIndex === "") {
        console.log("请选择");
      } else {
        if (this.moduleIndex === this.previewData.length - 1) {
          console.log("该已是最后一个");
        } else {
          let obj = this.previewData[this.moduleIndex];
          this.previewData.splice(this.moduleIndex, 1);
          this.previewData.splice(this.moduleIndex + 1, 0, obj);
          this.moduleIndex += 1;
          let data = [];
          this.previewData.map((value, index) => {
            let obj = {};
            obj.id = value.id;
            obj.sortValue = (index + 1) * 100;
            data.push(obj);
          });
          dbMall.postDBSortCustomize(data).then(res => {
            if (res.success) {
              console.log("成功");
            }
          });
        }
      }
    },
    // 删除
    deleteModule() {
      if (this.moduleIndex === "") {
        console.log("请选择");
      } else {
        let data = {};
        let index = this.moduleIndex;
        data.id = this.previewData[index].id;
        dbMall.postDBDeleteCustomize(data).then(res => {
          if (res.success) {
            this.previewData.splice(index, 1);
            this.changeAddContent();
          }
        });
      }
    },
    //显示右侧内容
    changeAddContent() {
      this.moduleIndex = "";
      this.id = "";
      this.fileList = [];
      this.link = "";
      this.goodsList = [];
    },
    //切换图片、商品状态
    changeStatus(status) {
      this.status = status;
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      } else {
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
    //图片删除
    onRemove() {
      this.fileList = [];
      this.link = "";
    },
    // 点击添加按钮
    addGoods() {
      this.dialogTableVisible = true;
      if (this.dialogTable) {
        this.$refs.dialogTable.clearSelection();
      }
    },
    // 搜索商品
    search() {
      this.dialogFormSearch = this.dialogForm;
      this.page = 1;
      this.getGoods();
    },
    // 选中表格
    handleSelectionChange(val) {
      this.dialogTable = val;
    },
    //删除单个商品
    removeGoods(index) {
      this.goodsList.splice(index, 1);
    },
    // 弹窗点击保存
    save() {
      this.$message.success("添加成功");
      let table = this.goodsList.concat(this.dialogTable);
      let newTable = [];
      for (var i = 0; i < table.length; i++) {
        var flag = true;
        for (var j = 0; j < newTable.length; j++) {
          if (table[i].id === newTable[j].id) {
            flag = false;
          }
        }
        if (flag) {
          newTable.push(table[i]);
        }
      }
      this.goodsList = newTable;
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      this.getGoods();
    },
    //关闭右侧内容
    cancel() {
      this.changeAddContent();
    },
    //保存模块
    addCustomize(type) {
      let data = {};
      if (type === 1) {
        if (this.fileList.length === 0) {
          this.$message.error("请上传图片");
          return false;
        } else {
          data.type = 1;
          data.pic = this.fileList[0].url;
          data.url = this.link;
        }
      } else if (type === 2) {
        if (this.goodsList.length === 0) {
          this.$message.error("请添加商品");
          return false;
        } else {
          data.type = 2;
          data.goodsIds = [];
          this.goodsList.map(value => {
            data.goodsIds.push(value.id);
          });
        }
      }
      console.log(this.id);
      if (this.id) {
        data.id = this.id;
        dbMall.postDBUpdateCustomize(data).then(res => {
          if (res.success) {
            this.$message.success("添加成功");
            this.getPreviewData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        dbMall.postDBAddCustomize(data).then(res => {
          if (res.success) {
            this.$message.success("添加成功");
            this.getPreviewData();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.phone-customize {
  width: 100%;
  height: 100%;
  .phone-customize-main {
    height: 100%;
    width: 789px;
    display: flex;
    justify-content: space-between;
    .preview {
      width: 375px;
      height: 100%;
      position: relative;
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      display: flex;
      flex-direction: column;
      align-items: center;
      .editor {
        position: absolute;
        right: -48px;
        top: 0;
        width: 32px;
        height: 145px;
        background: #fff;
        box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-evenly;
      }
      .preview-title {
        width: 375px;
        height: 40px;
        line-height: 40px;
        color: #666666;
        font-size: 16px;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
      }
      .preview-main {
        flex: 1;
        width: 375px;
        overflow: auto;
        .img-container {
          width: 100%;
          box-sizing: border-box;
          .img {
            width: 100%;
          }
        }
        .goods-container {
          width: 100%;
          box-sizing: border-box;
          .goods-list {
            width: 100%;
            .goods {
              width: 100%;
              height: 100px;
              border-bottom: 1px solid #eee;
              box-sizing: border-box;
              padding: 15px 12px;
              display: flex;
              align-items: center;
              .img {
                width: 70px;
                height: 70px;
                border-radius: 8px;
                margin-right: 14px;
              }
              .goods-content {
                width: 265px;
                .name {
                  font-size: 15px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  height: 32px;
                  line-height: 16px;
                  margin-bottom: 12px;
                }
                .price-detail {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .price {
                    color: #df3445;
                    font-size: 14px;
                  }
                  .detail {
                    width: 60px;
                    height: 24px;
                    font-size: 12px;
                    background: rgba(238, 238, 238, 1);
                    border-radius: 2px;
                    color: #999999;
                    line-height: 24px;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
        .add {
          font-size: 40px;
          width: 375px;
          height: 172px;
          padding: 16px;
          box-sizing: border-box;
          .content {
            background: rgba(246, 246, 246, 1);
            color: #999999;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 140px;
            cursor: pointer;
          }
        }
        .border {
          border: 2px solid #3d74f2;
        }
      }
      .preview-main::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      .preview-main::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 7px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ccc;
      }
      .preview-main::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
    }
    .add-content {
      width: 350px;
      height: 100%;
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: relative;
      .button {
        width: 100%;
        padding: 16px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .el-button {
          width: 150px;
        }
      }
      .img-container {
        flex: 1;
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        .img-upload {
          .title {
            font-size: 14px;
            color: #999999;
            padding: 15px 0 20px 0;
          }
          .link {
            display: flex;
            align-items: center;
            .link-lable {
              width: 80px;
            }
          }
        }
      }
      .goods-container {
        flex: 1;
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        overflow: auto;
        .add-goods {
          padding: 5px 0;
          .el-button {
            font-size: 14px;
          }
        }
        .goods-list {
          padding-bottom: 70px;
          .goods {
            height: 80px;
            background: rgba(246, 246, 246, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 12px;
            margin-bottom: 12px;
            position: relative;
            .img {
              width: 68px;
              height: 68px;
              border-radius: 8px;
              background: #ffffff;
            }
            .name {
              width: 215px;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              height: 48px;
              line-height: 24px;
            }
            .remove-goods {
              position: absolute;
              font-size: 12px;
              right: 5px;
              bottom: 5px;
              color: #df3445;
              cursor: pointer;
            }
          }
        }
      }
      .goods-container::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      .goods-container::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 7px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ccc;
      }
      .goods-container::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
      .bottom-btn {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #ffffff;
        width: 100%;
        height: 70px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      .bottom-btn:before {
        content: "";
        width: 318px;
        height: 1px;
        position: absolute;
        left: 16px;
        top: 0;
        background: #eee;
      }
    }
  }
  .page-url {
    padding-top: 16px;
    width: 375px;
    display: flex;
    .icon {
      width: 46px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      border-left: 0;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
<style lang='scss'>
.phone-customize {
  .el-carousel__indicators {
    display: none;
  }
  .upload {
    padding-bottom: 16px;
    .el-upload-list {
      .el-upload-list__item {
        width: 318px;
        height: auto;
        margin: 0;
        margin-bottom: 16px;
      }
    }
    .el-upload {
      width: 100%;
      height: 140px;
      background: rgba(246, 246, 246, 1);
      border: 0;
    }
    .none {
      .el-upload {
        display: none;
      }
    }
  }
  .el-dialog {
    border-radius: 4px;
    .el-dialog__header {
      padding: 0 16px;
      line-height: 48px;
      font-family: "PingFangSC-Medium";
      letter-spacing: 1px;
      .el-dialog__title {
        line-height: 24px;
        font-size: 16px;
        color: #606266;
      }
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
    .el-dialog__body {
      padding: 0px 16px 16px 16px;
      .border {
        border-bottom: 1px solid #f7f7f7;
        margin-bottom: 16px;
      }
      .input-search {
        margin-bottom: 16px;
        .el-select {
          margin-right: 16px;
          .el-input__inner {
            width: 128px;
          }
        }
        .w160 {
          width: 160px;
          height: 32px;
          line-height: 32px;
          margin-right: 16px;
          .el-input__suffix {
            height: 40px;
            top: -3px;
            right: 0px;
          }
          .el-input__inner {
            height: 32px;
            background: rgba(234, 238, 245, 0.2);
            border: 1px solid #eaeef5;
          }
        }
        .el-input.gray {
          width: 320px;
        }
        .btn-blue {
          width: 80px;
          margin-left: 16px;
        }
      }
      .el-table {
        .el-table__header {
          .el-checkbox {
            visibility: hidden;
          }
        }
        .list {
          margin-right: 16px;
          height: 32px;
          display: flex;
          align-items: center;
          > span {
            line-height: 32px;
          }
        }
        .el-input__suffix {
          height: 40px;
          top: -1px;
          right: 0px;
        }
        .gray.el-input {
          width: 80px;
          .el-input__inner {
            width: 80px;
          }
        }
      }
      .table_pagination {
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-pagination {
          height: 28px;
          padding: 0px;
          display: flex;
        }
      }
      #footer {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-button {
          width: 80px;
          height: 32px;
          margin-left: 24px;
          line-height: 0px;
          font-size: 14px;
        }
        .el-button.btn-white {
          border: 1px solid rgba(61, 116, 242, 1);
          color: #3d74f2;
        }
        .el-button.btn-white:hover {
          border: 1px solid rgba(61, 116, 242, 0.75);
          background: rgba(61, 116, 242, 0.75);
          color: #fff;
        }
        .el-button.btn-blue {
          border: 1px solid rgba(61, 116, 242, 1);
          color: #fff;
        }
        .el-button.btn-blue:hover {
          background: rgba(55, 103, 214, 1);
          border: 1px solid rgba(55, 103, 214, 1);
          color: #fff;
        }
      }
    }
  }
  .page-url {
    .url {
      height: 32px;
      .el-input__inner {
        height: 32px;
        border-radius: 0;
      }
    }
  }
}
</style>
